import moment from 'moment-timezone';

export type DateRange = [string, string, boolean?];
export type SingleDate = [string, null];
export type BookDate = DateRange | SingleDate;

const getCheckInDates = (dates: BookDate[]): string[] => dates.map((pair) => pair[0]);

const dateAlreadyInAnyRange = (date: string, ranges: DateRange[]): boolean =>
  !!ranges.find((range) => {
    const start = moment(range[0]);
    const end = moment(range[1]);
    if (moment(date).isBetween(start, end, 'day', '[]')) {
      return true;
    }
    return false;
  });

const rangeAlreadyContainedInAnotherRange = (
  checkedRange: DateRange,
  ranges: DateRange[]
): boolean =>
  !!ranges.find((range) => {
    const start = moment(range[0]);
    const end = moment(range[1]);

    const rangeContained =
      moment(checkedRange[0]).isBetween(start, end, 'day', '[]') &&
      moment(checkedRange[1]).isBetween(start, end, 'day', '[]');

    const rangeEqual = moment(checkedRange[0]).isSame(start) && moment(checkedRange[1]).isSame(end);

    if (rangeContained || rangeEqual) {
      return true;
    }
    return false;
  });

/**
 * @description
 * Remove duplicate dates and self contained date-ranges
 *
 * @param dates collection of dates and date-ranges
 * @returns cleared collection
 */
export const clearSingleDatesAndDateRanges = (dates: BookDate[]): BookDate[] => {
  const ranges: DateRange[] = dates.filter((pair) => !!pair[1]) as DateRange[];
  const singleDates: string[] = dates.filter((pair) => !pair[1]).map((pair) => pair[0]);
  const parsedRanges: DateRange[] = [];
  const parsedSingleDates: SingleDate[] = [];

  singleDates.forEach((date) => {
    if (
      !dateAlreadyInAnyRange(date, ranges) &&
      !getCheckInDates(parsedSingleDates).includes(date)
    ) {
      parsedSingleDates.push([date, null]);
    }
  });

  ranges.forEach((range) => {
    if (!rangeAlreadyContainedInAnotherRange(range, parsedRanges)) {
      // Here we check if there is a shorter range in the already parsed ranges;
      // We mark it as redundant if that is the case, and filter it out later below.
      parsedRanges.forEach((pRange) => {
        if (rangeAlreadyContainedInAnotherRange(pRange, [range])) {
          pRange.push(true);
        }
      });
      parsedRanges.push(range);
    }
  });
  const clearedRanges = parsedRanges.filter((range) => !range[2]);
  return [...parsedSingleDates, ...clearedRanges];
};
